<template>
  <v-app>
    <navigation id="navi" />
    <v-main
      style="max-width: 2480px; width:100%;"
      class="d-flex align-self-center"
    >
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Navigation from './components/navigation/NavigationComp.vue';

export default {
  name: 'App',

  components: {
    Navigation,
  },

  data() {
    return {};
  },
  methods: {
    ...mapActions({
      _checkToken: 'auth/checkToken',
      _getAllClients: 'account/getAllClients',
      _getUserData: 'account/getUserData',
      _checkCurrentClient: 'account/checkCurrentClient',
      _acquireAreas: 'areas/acquireAreas',
    }),
  },
  computed: {
    ...mapGetters({
      _clientIsSet: 'account/getClientIsSet',
      currentClient: 'account/getCurrentClient',
    }),
  },
  mounted() {
    this._acquireAreas();
  },
  watch: {
    '$route.params.client': function() {
      this._checkCurrentClient();
    },
    _clientIsSet() {
      if (this._clientIsSet) {
        this._acquireAreas();
      }
    },
    currentClient: {
      handler() {
        let link = document.querySelector("link[rel~='icon']");
        if (!link) {
          link = document.createElement('link');
          link.rel = 'icon';
          document.getElementsByTagName('head')[0].appendChild(link);
        }
        let url = '';
        if (this.currentClient.client_name === 'avis') {
          url = './assets/AVIS.png';
        } else if (this.currentClient.client_name === 'bazzbi') {
          url = './assets/bazzbi.png';
        } else {
          url = './assets/sharklogo.png';
        }
        link.href = url;
      },
      deep: true,
    },
  },
};
</script>

<style>
#app {
  font-family: 'Red Hat Text', sans-serif;
}
</style>
